module.exports = __webpack_public_path__ + "img/98990f2.png";